export default "__VITE_ASSET__D$kKBqwa__"